import { styled } from 'styled-components';

export const FormationSummaryPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.small};
  width: 100%;

  .controls {
    display: inline-flex;
    align-items: center;
    justify-content: end;
    gap: ${({ theme }) => theme.sizing.regular};
    color: ${({ theme }) =>
      theme.applyOpacity(theme.colours.ink.primary.main, 'secondary')};
    ${({ theme }) => theme.typography.bodyMedium}
  }
`;

export const FormationSummaryMainContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.regular};
  width: 100%;

  // chart & table tiles
  > div {
    flex: 1;
    align-self: flex-start;
    margin: 0;
  }

  // chart tile
  > div:nth-of-type(1) {
    align-self: flex-start;
    min-width: 400px;
    max-width: min(40%, 550px);
  }

  // table tile
  > div:nth-of-type(2) {
    align-self: flex-start;
    min-width: 0;

    .section-body {
      padding: 0;
      gap: 0;
    }
  }

  .section-body {
    min-height: 30rem;
    max-height: calc(100vh - 23rem);
    border-top: 1px solid ${({ theme }) => theme.colours.canvas.secondary.main};
  }
`;

export const GroupFix = styled.div`
  > div {
    display: -webkit-inline-box;
    margin-right: 50px;
  }
`;
GroupFix.displayName = 'GroupFix';

export const FormationSummarySectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${({ theme }) => theme.typography.headingMedium}
`;

export const FormationSummaryChartContainer = styled.div`
  overflow: auto;
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colours.layering[1].strong};
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.small};
`;

FormationSummaryPage.displayName = 'FormationSummaryPage';
FormationSummaryMainContent.displayName = 'FormationSummaryMainContent';
FormationSummarySectionHeader.displayName = 'FormationSummarySectionHeader';
FormationSummaryChartContainer.displayName = 'FormationSummaryChartContainer';
Controls.displayName = 'Controls';
